import { mapTileType } from "../../../utils/maps/MapConstants";

const MAP_TILE_TYPES: mapTileType[] = ["BASE", "WEATHER"];

export const getMapTileSourceId = (id: mapTileType) =>
  `azure-${id.toLowerCase()}-source`;

export const getMapTileLayerId = (id: mapTileType) =>
  `azure-${id.toLowerCase()}-layer`;

export const getMapTileTypeFromSourceId = (
  sourceId: string
): mapTileType | undefined =>
  MAP_TILE_TYPES.find((type) => getMapTileSourceId(type) === sourceId);
